import React from "react";
import MaterialIcon from "../BuilderComponents/MaterialIcon";

const SearchBoxPreview = ({ config, classes }) => {
  return (
    <div className="position_relative">
      <input className={`z-rv-searchBox ${classes}`} placeholder={config.placeholder} />
      <MaterialIcon name="search" className="z-search-icon" />
    </div>
  );
};

export default SearchBoxPreview;
